import React from 'react';
import PropTypes from 'prop-types';

import { Image } from 'components/core/Image';
import { Paragraph } from 'components/core/Typography';

import './MarketingStepCard.scss';

function MarketingStepCard({ stepCard }) {
	return (
		<div className="step-card">
			<Image
				className="step-card-image"
				src={stepCard.imageSrc}
				alt="image step card"
			/>
			<Paragraph
				size="tiny"
				weight="extraBold"
				color="placeholderGray"
			>
				{stepCard.step}
			</Paragraph>
			<Paragraph
				size="medium"
				weight="extraBold"
				color="darkGray"
			>
				{stepCard.title}
			</Paragraph>
			<Paragraph
				weight="standard"
				color="darkGray"
			>
				{stepCard.description}
			</Paragraph>
		</div>
	);
}

MarketingStepCard.propTypes = {
	stepCard: PropTypes.objectOf(
		PropTypes.shape({
			imageSrc: PropTypes.string,
			step: PropTypes.string,
			title: PropTypes.string,
			description: PropTypes.string,
		}),
	),
};

export default MarketingStepCard;
